export default "__VITE_ASSET__d1dabeb0__"